import React, { useEffect, useState } from 'react';
import { FormControl, Grid, TextField } from '@material-ui/core';
import { ModalWithButtons } from '../ModalWithButtons/ModalWithButtons.component';
import { format } from 'date-fns';
import { useStyles } from './TokenAuthUserComponent.styles';

interface TokenAuthUserProps {
  open: boolean;
  token: string;
  prevToken: string;
  smsNumber: number | null;
  timer: number | null;
  leftAttemts: number | null;
  smsExpireDateTime: Date | null;
  setToken(token: string): void;
  onCancel: () => void;
  handleConfirmUpdate: () => void;
}

interface Char {
  id: string;
  value: string;
}

const emptyTokenInput = [
  {
    id: '1',
    value: '',
  },
  {
    id: '2',
    value: '',
  },
  {
    id: '3',
    value: '',
  },
  {
    id: '4',
    value: '',
  },
  {
    id: '5',
    value: '',
  },
  {
    id: '6',
    value: '',
  },
];

export const TokenAuthUser: React.FC<TokenAuthUserProps> = (props) => {
  const classes = useStyles();

  const [tokenInput, setTokenInput] = useState<Char[]>(emptyTokenInput);

  const handleChangeToken = (
    event: React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>,
    currentFieldId: string,
    nextFieldID: string,
  ) => {
    const value = event.target.value;
    if ((value.length && isNaN(parseInt(value))) || value.length > 1) return;
    setTokenInput((prevState) => {
      return prevState.map((item) =>
        item.id !== currentFieldId
          ? item
          : {
              ...item,
              value: value,
            },
      );
    });
    if (value.length && nextFieldID.length) {
      const field = document.getElementById(nextFieldID);
      if (field) {
        field.focus();
      }
    }
  };

  useEffect(() => {
    const token = tokenInput.map((e) => e.value).join('');
    props.setToken(token);
  }, [tokenInput]);

  useEffect(() => {
    if (!props.token.length) {
      setTokenInput(emptyTokenInput);
    }
  }, [props.token]);

  const isConfirmationDisabled = tokenInput.some((e) => e.value === '');

  return (
    <>
      <ModalWithButtons
        open={props.open}
        size="sm"
        autoHeight={true}
        onCancel={props.onCancel}
        onConfirm={props.handleConfirmUpdate}
        confirmButtonDisabled={isConfirmationDisabled}
        confirmButtonLabel="Ok"
        buttonsContainerStyle={{ marginTop: '20px', textAlign: 'center' }}
      >
        <Grid container className={classes.container}>
          <Grid>
            <div className={classes.text}>
              {props.prevToken === '' ? (
                <>
                  Podaj kod autoryzacyjny nr {props.smsNumber} z dnia{' '}
                  {props.smsExpireDateTime ? format(props.smsExpireDateTime, 'dd-MM-yyyy') : ''} wysłany na Twój numer
                  telefonu komórkowego{' '}
                </>
              ) : (
                <>
                  Wprowadzony kod {props.prevToken} jest niepoprawny, wprowadź ponownie. Pozostały {props.leftAttemts}{' '}
                  próby.{' '}
                </>
              )}
            </div>
          </Grid>

          <Grid item xs={12} className={classes.item}>
            {[...tokenInput].map((char) => (
              <FormControl key={char.id}>
                <TextField
                  id={`char${char.id}`}
                  style={{ margin: '5px' }}
                  variant="outlined"
                  type="text"
                  value={char.value}
                  onChange={(event) => handleChangeToken(event, char.id, `char${parseInt(char.id) + 1}`)}
                  inputProps={{
                    style: {
                      width: '20px',
                      height: '20px',
                      padding: '10px',
                      fontSize: '18px',
                      textAlign: 'center',
                    },
                    onKeyDown: (event) => {
                      if (event.key === 'Backspace' && (event.target as HTMLInputElement).value === '') {
                        const prevInput = document.getElementById(`char${parseInt(char.id) - 1}`);
                        if (prevInput && typeof prevInput.focus === 'function') {
                          prevInput.focus();
                          event.preventDefault();
                        }
                      }
                    },
                  }}
                />
              </FormControl>
            ))}
          </Grid>
          <Grid>
            <div className={classes.text}>
              Ważność kodu <span style={{ color: '#BC0000' }}>{props.timer}</span> sekund
            </div>
          </Grid>
        </Grid>
      </ModalWithButtons>
    </>
  );
};

interface TokenAuthUserExpiredProps {
  open: boolean;
  onCancel: () => void;
  onConfirm: () => void;
}

export const TokenAuthUserExpired: React.FC<TokenAuthUserExpiredProps> = (props) => {
  const classes = useStyles();

  return (
    <>
      <ModalWithButtons
        open={props.open}
        size="sm"
        autoHeight={true}
        onCancel={props.onCancel}
        onConfirm={props.onConfirm}
        confirmButtonLabel="Tak"
        cancelButtonLabel="Nie"
        buttonsContainerStyle={{ marginBottom: '25px', textAlign: 'center' }}
      >
        <Grid container className={classes.container}>
          <Grid>
            <div className={classes.text}>
              Termin ważności kodu autoryzacyjnego upłynął.
              <br />
              Czy wygenerować nowy kod?
            </div>
          </Grid>
        </Grid>
      </ModalWithButtons>
    </>
  );
};
